import React, { useEffect } from 'react';
import { LayoutDashboard } from 'lucide-react';
import { useAuthStore } from '../store/useAuthStore';
import { useDashboardStore } from '../store/useDashboardStore';
import PortfolioSummaryWidget from '../components/dashboard/widgets/PortfolioSummaryWidget';
import MyValuationsWidget from '../components/dashboard/widgets/MyValuationsWidget';
import QuickValuationWidget from '../components/dashboard/widgets/QuickValuationWidget';
import CreditsUsageWidget from '../components/dashboard/widgets/CreditsUsageWidget';
import AccountBillingWidget from '../components/dashboard/widgets/AccountBillingWidget';
import ComparisonMatrixWidget from '../components/dashboard/widgets/ComparisonMatrixWidget';
import PropertyAnalyticsWidget from '../components/dashboard/widgets/PropertyAnalyticsWidget';

export default function Dashboard() {
  const { user } = useAuthStore();
  const { fetchValuations, isLoadingValuations } = useDashboardStore();

  useEffect(() => {
    if (user?.id) {
      fetchValuations(user.id, true);
    }
  }, [user?.id, fetchValuations]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
              <LayoutDashboard className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
              <p className="text-sm text-gray-500">
                Your portfolio overview and valuation tools
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Widget Grid */}
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Row 1: Portfolio Summary (2 cols) + Credits & Usage (1 col) */}
          <div className="md:col-span-2">
            <PortfolioSummaryWidget />
          </div>
          <div className="md:col-span-2 lg:col-span-1">
            <CreditsUsageWidget />
          </div>

          {/* Row 2: My Valuations (2 cols) + Quick Valuation & Account (1 col) */}
          <div className="md:col-span-2">
            <MyValuationsWidget />
          </div>
          <div className="md:col-span-2 lg:col-span-1 space-y-6">
            <QuickValuationWidget />
            <AccountBillingWidget />
          </div>

          {/* Row 3: Comparison Matrix (full width) */}
          <div className="md:col-span-2 lg:col-span-3">
            <ComparisonMatrixWidget />
          </div>

          {/* Row 4: Property Analytics (full width) */}
          <div className="md:col-span-2 lg:col-span-3">
            <PropertyAnalyticsWidget />
          </div>
        </div>
      </div>
    </div>
  );
}
